// Pulls speaker notes from the current slide of the speaker iframe.
// Notes live in <aside class="notes"> on the slide DOM (reveal.js convention).

const FONT_KEY = 'rs_notes_font_v1';
const MIN_PX = 11;
const MAX_PX = 36;
const STEP   = 2;
const DEFAULT_PX = 18;

function loadFont() {
  try { const v = parseInt(localStorage.getItem(FONT_KEY), 10); return Number.isFinite(v) ? v : DEFAULT_PX; }
  catch { return DEFAULT_PX; }
}
function saveFont(px) { try { localStorage.setItem(FONT_KEY, String(px)); } catch {} }

export default {
  id:   'notes',
  slot: 'notes',
  mount({ slot, deck }) {
    slot.innerHTML = `
      <div class="panel-header">
        <span>Notes</span>
        <span class="font-controls">
          <button data-cmd="smaller" title="Decrease font size (−)">A−</button>
          <button data-cmd="larger"  title="Increase font size (+)">A+</button>
        </span>
      </div>
      <div class="notes-body" data-role="body"></div>
    `;
    const body = slot.querySelector('[data-role="body"]');

    let px = loadFont();
    const applyFont = () => { body.style.fontSize = px + 'px'; };
    applyFont();

    slot.querySelector('[data-cmd="smaller"]').addEventListener('click', () => {
      px = Math.max(MIN_PX, px - STEP); applyFont(); saveFont(px);
    });
    slot.querySelector('[data-cmd="larger"]').addEventListener('click', () => {
      px = Math.min(MAX_PX, px + STEP); applyFont(); saveFont(px);
    });

    const update = () => {
      const html = deck.getCurrentNotes();
      body.innerHTML = html || '<em style="color:var(--fg-muted)">no notes</em>';
    };

    deck.onReady(() => {
      update();
      deck.reveal.on('slidechanged',   update);
      deck.reveal.on('fragmentshown',  update);
      deck.reveal.on('fragmenthidden', update);
    });
  },
};
